/**
 * Digest card. Backend returns Telegram-HTML; we render only `<b>` tags
 * (the single tag BuildDigest emits) and strip anything else as a
 * defence-in-depth XSS guard.
 */
import { AssistantBubble } from "./AssistantBubble";
import { RelativeTime } from "../../components/RelativeTime";
import type { DigestMessage } from "../types";

interface Props {
  message: DigestMessage;
}

export function DigestBubble({ message }: Props): React.ReactElement {
  return (
    <AssistantBubble
      title={message.period === "day" ? "Daily digest" : "Weekly digest"}
      meta={<RelativeTime iso={message.createdAt} />}
    >
      <div
        className="text-[13px] leading-[18px] whitespace-pre-wrap"
        dangerouslySetInnerHTML={{ __html: stripUnsafeTags(message.content) }}
      />
    </AssistantBubble>
  );
}

function stripUnsafeTags(html: string): string {
  return html.replace(/<(?!\/?b\s*\/?>)[^>]*>/gi, "");
}
